import { Link } from "@/components/LocalLink";
import { WORDMARK } from "@/components/Header";
import { SAFETY_NOTE, CONTACT_EMAIL } from "@/data/policies";
import { CorrespondenceStrip } from "@/components/Correspondence";

const COLS = [
  ["SHOP", [["All jars", "/shop"], ["Discovery Dram", "/products/discovery-dram"], ["Standing Orders", "/standing-orders"], ["Find your jar", "/find-your-jar"]]],
  ["ABOUT", [["Our Story", "/our-story"], ["Our Standard", "/our-standard"], ["Senior dogs", "/senior-dogs"], ["Journal", "/journal"]]],
  ["HELP", [["Questions", "/help#questions"], ["How to use", "/help#how-to-use"], ["Shipping & Returns", "/policies/shipping-returns"], ["Write to us", `mailto:${CONTACT_EMAIL}`]]],
];
const slug = (l) => l.toLowerCase().replace(/&/g, "and").replace(/\s+/g, "-");

export const ClosingBlock = () => (
  <div className="wrap">
    <div className="closing" data-testid="closing-block">
      <div className="eyebrow">Meet the jars</div>
      <h3>Four preparations, one for each kind of dog.</h3>
      <div className="row">
        <Link to="/shop" className="btn btn-primary" data-testid="closing-shop">Shop the jars</Link>
        <Link to="/find-your-jar" className="btn btn-ghost" data-testid="closing-quiz">Find your dog's jar</Link>
      </div>
    </div>
  </div>
);

export const Footer = ({ closing = false }) => (
  <>
    {closing && <ClosingBlock />}
    <footer data-testid="site-footer">
      <div className="wrap">
        <CorrespondenceStrip />
        <div className="cols">
          <div>
            <img src={WORDMARK} alt="Dirty Paws Apothecary" style={{ height: 34, marginBottom: 14 }} />
            <p>Mushroom preparations for dogs, made slowly in Alberta, by humans outnumbered by dogs.</p>
          </div>
          {COLS.map(([title, links]) => (
            <div key={title}>
              <h5>{title}</h5>
              <ul>
                {links.map(([label, href]) => (
                  <li key={label}>
                    {href.startsWith("mailto:") ? <a href={href} data-testid={`footer-${slug(label)}`}>{label}</a>
                      : <Link to={href} data-testid={`footer-${slug(label)}`}>{label}</Link>}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="care" data-testid="footer-safety-note">
          A word of care: {SAFETY_NOTE} © {new Date().getFullYear()} Dirty Paws Apothecary · Ships within Canada ·{" "}
          <Link to="/policies/privacy">Privacy</Link> · <Link to="/policies/terms">Terms</Link>
        </div>
      </div>
    </footer>
  </>
);
